import React from 'react';
interface BrandLogoProps {
  className?: string;
}
export function BrandLogo({
  className = ''
}: BrandLogoProps) {
  return <span className={`inline-flex flex-col leading-none ${className}`} data-id="element-326" data-mp="2zqeboblzx4si">
      <svg viewBox="0 0 120 22" aria-hidden="true" className="h-[14px] w-[104px] text-brand-700" fill="none" data-id="element-327" data-mp="2ura23jv5t51n">
        <path d="M2 20 L34 4 L52 14 L74 2 L118 20" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round" data-id="element-328" data-mp="2pqvshxdwtn1i" />
        <path d="M52 14 L52 20" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" data-id="element-329" data-mp="3iifji3gr05e2" />
        <rect x="44" y="9" width="5" height="5" fill="currentColor" data-id="element-330" data-mp="3dgq5qg255dma" />
      </svg>
      <span className="mt-1 font-display text-[17px] font-extrabold tracking-tight text-graphite-800" data-id="element-331" data-mp="38ioo7zkd5mcx">
        Mortgage<span className="text-brand-700" data-id="element-332" data-mp="224pbilmicwz5">Pros</span>
      </span>
    </span>;
}